























































































































































import { Component, Vue } from "vue-property-decorator";
import { UserProfile, Miner, Share, Currency } from "@/interfaces";
import { dispatchGetMiners, dispatchGetMiner } from "@/store/main/actions";
import { readHasAdminAccess, readOneMiner } from "@/store/main/getters";
import { readAdminOneUser } from "@/store/admin/getters";
import { dispatchGetUsers } from "@/store/admin/actions";
import TimeSeriesChart from "@/components/TimeSeriesChart.vue";
import Sparkline from "vue-sparklines";
import { Data } from "../Shares.vue";
import { readCurrencies } from "@/store/wallet/getters";

@Component({
  components: {
    TimeSeriesChart,
    Sparkline
  }
})
export default class ShowMiner extends Vue {
  public valid = true;
  public loading = true;

  public miner: Miner | null = null;
  public user: UserProfile | null = null;
  public shares: Share[] | null = null;

  public admin = false;

  private allData: Data[] = [];
  private chartData: Chart.ChartData = {};
  private chartStyles = {
    height: "100%",
    width: "100%",
    margin: "auto"
  };

  private share_summations = {};

  private time_diff = 0;

  public get_sums = {
    sum_valid: 0,
    sum_stale: 0,
    sum_invalid: 0
  };

  public async mounted() {
    this.loading = true;
    const promises = [
      dispatchGetMiner(this.$store, {
        id: this.$router.currentRoute.params.id
      })
    ];
    if (readHasAdminAccess(this.$store)) this.admin = true;
    // if (this.admin) {
    //   promises.push(dispatchGetUsers(this.$store));
    // }
    await Promise.allSettled(promises);

    const miner = readOneMiner(this.$store)(
      +this.$router.currentRoute.params.id
    );
    if (miner) {
      this.miner = miner;
    }

    // const user = readAdminOneUser(this.$store)(this.miner!.owner_id);
    if (this.miner?.owner) {
      this.user = this.miner.owner;
    }
    if (this.miner?.shares) {
      this.shares = this.miner.shares.sort((s1, s2) => {
        if (s1 > s2) {
          return 1;
        }

        if (s1 < s2) {
          return -1;
        }

        return 0;
      });
    }

    if (this.shares && this.shares.length) {
      // summations
      const time_start = new Date(this.shares[this.shares.length - 1].created);
      const time_end = new Date(this.shares[0].created);

      console.log(time_start.getTime(), time_end.getTime());

      this.time_diff = (time_end.getTime() - time_start.getTime()) / 10 ** 3;

      console.log(this.time_diff);

      let sum_valid = 0;
      let sum_stale = 0;
      let sum_invalid = 0;
      this.shares.forEach(share => {
        sum_valid += share.valid_count;
        sum_stale += share.stale_count;
        sum_invalid += share.invalid_count;
      });
      this.get_sums.sum_valid = sum_valid;
      this.get_sums.sum_stale = sum_stale;
      this.get_sums.sum_invalid = sum_invalid;

      // Initialize chart data
      this.allData.push({ label: "نامعتبر", data: [] });
      this.allData.push({ label: "دیر هنگام", data: [] });
      this.allData.push({ label: "معتبر", data: [] });

      for (const share of this.shares) {
        console.log(share.created);
        if (share.created in this.share_summations) {
          this.share_summations[share.created] = [
            this.share_summations[share.created][0] + share.valid_count,
            this.share_summations[share.created][1] + share.stale_count,
            this.share_summations[share.created][2] + share.invalid_count
          ];
        } else {
          this.share_summations[share.created] = [
            share.valid_count,
            share.stale_count,
            share.invalid_count
          ];
        }
      }

      for (const key in this.share_summations) {
        const val = this.share_summations[key];
        this.allData[2].data.push({
          x: new Date(key + "Z"),
          y: val[0]
        });
        this.allData[1].data.push({
          x: new Date(key + "Z"),
          y: val[1]
        });
        this.allData[0].data.push({
          x: new Date(key + "Z"),
          y: val[2]
        });
      }
      for (let i = 0; i < 3; i++) {
        this.allData[i].data = this.allData[i].data.sort((s1, s2) => {
          if (s1.x > s2.x) {
            return 1;
          }

          if (s1.x < s2.x) {
            return -1;
          }

          return 0;
        });
      }

      const dataset = (labelData: Data) => ({
        label: labelData.label,
        data: labelData.data,
        radius: 5
      });
      this.chartData = {
        datasets: this.allData.map(label => dataset(label))
      };

      console.log(this.chartData);

      // // group by miners
      // for (const share of shares) {
      //   if (share.miner_id in this.share_miners) {
      //     this.share_miners[share.miner_id].push(share);
      //   } else {
      //     this.share_miners[share.miner_id] = [share];
      //   }
      // }
    }

    this.loading = false;
  }

  public cancel() {
    this.$router.back();
  }

  public async edit() {
    this.$router.push({
      name: "main-miners-edit",
      params: { id: this.$router.currentRoute.params.id }
    });
  }

  public async remove() {
    this.$router.push({
      name: "main-miners-remove",
      params: { id: this.$router.currentRoute.params.id }
    });
  }

  // getHashrate(hashrate: number | null | undefined) {
  //   if (hashrate) {
  //     return (hashrate / 10 ** 6).toFixed(2) + "MH";
  //   }
  //   return "0.00MH";
  // }

  public getHashrate(hashrate: number, currency_id: number) {
    let unit = "MH";
    let fix_number = 2;
    let power_number = 6;
    if(this.getCurrencyName(currency_id) == "XCC" ||  this.getCurrencyName(currency_id) == "XCH"){
      unit = "TB";
      fix_number = 5;
      power_number = 12;
    }
    return (hashrate / 10 ** power_number).toFixed(fix_number) +unit;
  }

  public getCurrencyName(currency_id: number) {
    return readCurrencies(this.$store).find(
      (currency: Currency) => currency.id === currency_id
    )!.name;
  }

  public hashText(currency_id){
    const currency = this.getCurrencyName(currency_id)
    if (currency == "XCC" || currency == "XCC")
      return "حجم"
    else
      return "نرخ هش"
  }

  get state() {
    const state = this.miner?.is_active;
    if (state) {
      return "فعال";
    }
    return "غیر فعال";
  }

  get isActive(){
    return this.miner?.is_active;
  }

  public getColor() {
    if (this.state === "فعال") {
      return "color:green";
    } else {
      return "color:red";
    }
  }
}
